import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { reduxForm } from 'redux-form';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { CancelButton } from '../../../../../../../../components/buttons';
  
class TargetInstructionModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,            
            targetInstructionDetails: this.props.targetInstructionDetails ? this.props.targetInstructionDetails : '',            
        }
    }
    
    componentWillMount = () => {
    }


    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} btnlabel="Close" />            
        ];
        return (
            <Dialog
                className="custom_modal"
                title={this.props.targetObj.targetName}
                modal={false}
                open={this.state.open}       
                actions={actions}        
                autoScrollBodyContent={true}
            >
                {this.renderLoading()}
                <div className="row mt-20">
                    <div className="col-sm-12">
                        <div className="row mt-10">
                            <div className='col-sm-12'>
                                <span><b>Target Instruction :</b>&nbsp;{this.state.targetInstructionDetails}</span>
                            </div>
                        </div>                            
                        <div className="row mt-10" style={{ marginLeft: '0px' }}>
                    </div>                        
                    </div>
                </div>
            </Dialog>
        )
    }
}

TargetInstructionModal = reduxForm({
    form: 'TargetInstructionModalForm',
    // validate,
    enableReinitialize: true,
})(TargetInstructionModal);

function mapStateToProps(state, ownProps) {
    return {
        loading: state.patientSkillAcqActiveTarget.loadingTaskAnalysis || state.patientSkillAcqActiveTarget.loading
    }
}

export default connect(mapStateToProps)(TargetInstructionModal);


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Maintenance/components/targets/TargetInstructionModal.js